
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import InfiniteLoading from 'vue-infinite-loading'
import {
    Header,
    GoodsList,
} from '@/components/customPromotion'
import {
    getStoreInfo,
    getPromotionGoodsInfo
} from '@/models/custom'

export default {
    name: viewName.customSingularGoodsList,
    inject: ['showLoading', 'hideLoading'],
    components: {
        InfiniteLoading,
        Header,
        GoodsList,
    },
    data () {
        return {
            detailParams: {
                sstore_id: '', // 门店id(单店商品必传，多点不用传)
                store_id: '', // 商家id
                topic_id: '', // 推广id
                topic_type: 1, // 类型，0：常规，1：自定义
                latitude: '',
                longitude: '',
                page_code: '',
                floor_id: '',
            },
            page_size: 10,
            page_no: 1,
            sstoreInfo: {
                sstore_name: '', // 门店名称
                sstore_address: '', // 门店地址
                sstore_phone: '', // 门店电话
                distance: '', // 距离
            },
            keywords: '', // 搜索关键词
            goodsList: [
                // {
                //     spu_id: '', // 商品规格id
                //     goods_id: '', // 商品id
                //     goods_img: '', // 商品图片
                //     goods_name: '', // 商品名称
                //     goods_price: '', // 商品原价
                //     goods_present_price: '', // 商品现价
                //     goods_sell_out: 1 || 0, // 是否已售罄, 0: 未售罄, 1： 已售罄
                // }
            ],
        }
    },
    computed: {
        ...mapState({

        }),
        storeInfo () {
            const obj = {
                store_name: '', // 门店名称
                store_address: '', // 门店地址
                distance: '', // 距离
            }
            return this.detailParams.store_id ? obj : null
        }
    },
    created () {
        this.setAppClass({
            isAppend: true,
            className: 'bgGreyColor'
        })
        this.$emit('setHeader', {
            title: this.$route.query.title || '商品列表',
            showHeader: true,
            showLeft: true,
        })
        Object.assign(this.detailParams, this.$route.query)
    },
    activated () {
    },
    mounted () {
        document.body.scrollIntoView()
        this.getStoreMsg()
    },
    methods: {
        ...mapActions([
            'setAppClass'
        ]),
        infinite () {
            this.getGoodsListInfo()
        },
        headerCallback (params) {
            const { type, value } = params
            if (type === 'search') {
                this.page_no = 1
                this.goodsList = []
                this.keywords = value
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
            }
        },
        goodsListCallback (params) {
            const { value, cb } = params
            const query = JSON.parse(JSON.stringify(this.detailParams))
            delete query.title
            Object.assign(value, query)
            cb(value)
        },
        getStoreMsg () {
            this.showLoading()
            const { latitude, longitude, sstore_id } = this.detailParams
            if (!latitude && !longitude) return
            getStoreInfo({ sstore_id, latitude: this.detailParams.latitude, longitude: this.detailParams.longitude })
                .then(res => {
                    this.hideLoading()
                    Object.assign(this.sstoreInfo, res)
                })
                .catch(_ => {
                    this.hideLoading()
                })
        },
        getGoodsListInfo () {
            getPromotionGoodsInfo({
                topic_type: this.detailParams.topic_type,
                topic_id: this.detailParams.topic_id || '',
                sstore_id: this.detailParams.sstore_id || '',
                store_id: this.detailParams.store_id,
                floor_id: this.detailParams.floor_id || '',
                keywords: this.keywords,
                page: this.page_no,
                pagesize: this.page_size
            })
                .then(data => {
                    this.goodsList.push(...data)
                    if (data.length < this.page_size) {
                        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                    } else {
                        this.page_no += 1
                        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
    },
    destroyed () {

    },
}
